import { cva } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
            destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
            outline: 'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
            secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
            blue: 'bg-[#32ADE6] border border-[#32ADE6] text-white hover:bg-white hover:text-[#32ADE6] shadow-sm transition-all duration-300 ease-in-out',
            orange: 'bg-[#E66A63] border border-[#E66A63] text-white hover:bg-white hover:text-[#E66A63] shadow-sm transition-all duration-300 ease-in-out',
            action: 'bg-action border border-action text-white hover:bg-white hover:text-action dark:bg-[#fafafa] dark:text-black dark:hover:bg-black dark:hover:text-white dark:border-[#fafafa] transition-all duration-300 ease-in-out',
            ghost: 'hover:bg-accent hover:text-accent-foreground',
            link: 'text-primary underline-offset-4 hover:underline',
            success: 'bg-green-600 text-white shadow hover:bg-green-700',
        },
        size: {
            default: 'h-9 px-4 py-2',
            sm: 'h-8 rounded-md px-3 text-xs',
            lg: 'h-10 rounded-md px-8',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
